// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChartHeaderMenu-module__menuContainer--a5WrU{box-shadow:0px 0px 4px 0px rgba(0,0,0,.2509803922);width:240px;border-radius:5px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuContainer": `ChartHeaderMenu-module__menuContainer--a5WrU`
};
module.exports = ___CSS_LOADER_EXPORT___;
